/*
 * Copyright (C) Fraunhofer IESE 2021-2024 - Bestin John, Alexander Kapincev,
 * Matthias Gerbershagen, Pedram (Majid) Jokar, Adeline Silva Schäfer, Steffen Hupp,
 * Arian Ajdari, Kazi Rahman.
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const APP_NAME = import.meta.env.VITE_APP_NAME;
